import { render, staticRenderFns } from "./ySeal.vue?vue&type=template&id=bd60b640&scoped=true&"
import script from "./ySeal.vue?vue&type=script&lang=js&"
export * from "./ySeal.vue?vue&type=script&lang=js&"
import style0 from "./ySeal.vue?vue&type=style&index=0&id=bd60b640&lang=scss&scoped=true&"
import style1 from "./ySeal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd60b640",
  null
  
)

export default component.exports